import { z } from 'zod';
import { RequiredZipAddressSchema } from './address';
import { UUIDSchema } from './common';
const AssetMapItemShape = {
    asset_uuid: UUIDSchema,
    title: z.string(),
    customer_uuid: UUIDSchema,
    customer_asset_reference: z.string().nullable().optional(),
    address: RequiredZipAddressSchema,
};
export const AssetMapItemSchema = z.object(AssetMapItemShape);
const AssetMapShape = { assets: z.array(AssetMapItemSchema) };
export const AssetMapSchema = z.object(AssetMapShape);
const AssetOrderAddressSchema = RequiredZipAddressSchema.omit({ coordinates: true });
const AssetWithOrderShape = {
    asset_uuid: UUIDSchema,
    asset_title: z.string(),
    asset_title_image: z.string().optional(),
    asset_title_thumbnail_image: z.string().optional(),
    customer_asset_reference: z.string().optional(),
    portfolio_uuid: UUIDSchema.optional(),
    portfolio_title: z.string().optional(),
    order_date: z.string().optional(),
    due_date: z.string().optional(),
    inspection_date: z.string().optional(),
    valuation_date: z.string().optional(),
    company_name: z.string().optional(),
    first_name: z.string().optional(),
    last_name: z.string().optional(),
    address: AssetOrderAddressSchema,
};
export const AssetWithOrderSchema = z.object(AssetWithOrderShape);
const AssetsWithOrdersShape = { orders: z.array(AssetWithOrderSchema) };
export const AssetsWithOrdersSchema = z.object(AssetsWithOrdersShape);
